import { call } from 'redux-saga/effects'
import reqProvider from '../coreRequests'
import { BASE_API } from '../urlPaths'

export function* getLatestExchangeRates(): any {
  const path = `${BASE_API}/currency-rates/latest`
  const data: any = yield call(reqProvider.getReq, path)
  return data ?? []
}
